import staticConfig from '../staticConfig.json';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const { setEnvPrefix } = ssCommonUtils;

export const
getPortalData = (d, p) => d != null && d.hasOwnProperty(p) ? d[p] : null,
injectLinkConfig = baseId => {
    let idSet = new Set();

    for(let i=0; ; i++) {
        let element = document.getElementById(`${baseId}-${i}`);
        if(element == null) break;
        else idSet.add(`${baseId}-${i}`);
    }

    idSet.forEach((id, i) => {
        let elements = document.getElementById(id).getElementsByTagName('a');
        let images = document.getElementById(id).getElementsByTagName('img');
        Object.keys(elements).map(k => {
            if(elements.item(k)){
            let
            el = elements.item(k),
            href = elements.item(k).getAttribute('href');

            if(
                el != null &&
                href != null &&
                (href.indexOf('{') !== -1 && href.indexOf('{') === 0) &&
                (href.indexOf('}') !== -1 && href.indexOf('}') === href.length - 1)
            ) {
                el.setAttribute('href', setEnvPrefix(getStaticContentConfig(href.substring(1, href.length - 1))));
                if(el.getAttribute('tab-title') != null) el.addEventListener('click', () => openTab(el));
            }
          }
        });

        Object.keys(images).map(k => {
          let
          img = images.item(k),
          src = images.item(k).getAttribute('src');

          if(
            img != null &&
            src != null &&
            (src.indexOf('{') !== -1 && src.indexOf('{') === 0) &&
            (src.indexOf('}') !== -1 && src.indexOf('}') === src.length - 1)
          ){
            img.setAttribute('src', getStaticContentConfig(src.substring(1, src.length -1)));
          }
        });
    });
}

const
getStaticContentConfig = configPath => {
    let
    ref = {...staticConfig},
    path = configPath.split('.');

    for(let p in path)
        if(ref.hasOwnProperty(path[p]))
            ref = ref[path[p]];

    return ref;
},
openTab = e => {
    let
    href = e.getAttribute('href'),
    title = e.getAttribute('tab-title'),
    win = window.open(href, '_blank');

    win.addEventListener('load', () => win.document.title = title);
    event.returnValue =  false;
};
